export default "__VITE_ASSET__3e36a843__"